"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
var channel_1 = require("./channel");
/* SATURATION */
function saturation(color) {
    return channel_1.default(color, 's');
}
/* EXPORT */
exports.default = saturation;



//////////////////
// WEBPACK FOOTER
// ./~/khroma/dist/methods/saturation.js
// module id = 2189
// module chunks = 0